import React, { ReactElement, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { CognitoUser } from '@aws-amplify/auth';
import { useHistory, useLocation } from 'react-router-dom';

import { deleteUser, getProfile } from '../../utils/auth-functions';
import CardHeader from '../organisms/CardHeader';

export interface CognitoUserAttributes {
  name?: string,
  family_name?: string,
  nickname?: string
}

type CustomCognitoUser = CognitoUser & { attributes: CognitoUserAttributes };

export default function DeleteProfile(): ReactElement {
  const [profile, setProfile] = useState<CustomCognitoUser | string | undefined>(undefined);

  const history = useHistory();
  const { search } = useLocation();
  const queryString = new URLSearchParams(search);
  const redirectUrl = typeof queryString.get('redirectUrl') === 'string' ?
    decodeURIComponent(queryString.get('redirectUrl') || '') :
    '';

  useEffect(() => {
    const getProfileData = async () => {
      await getProfile()
        .then((res) => setProfile(res));
    };
    getProfileData();
  }, []);
  
  useEffect(() => {
    if (profile && profile === 'The user is not authenticated') {
      history.replace(redirectUrl ? `/login?redirectUrl=${redirectUrl}` : '/login');    
    }
  }, [profile]);
  
  const handleDeleteProfile = () => {
    if (redirectUrl) Cookies.set('redirectDeleteUser', redirectUrl);
    const accessToken = (profile && typeof profile !== 'string') ? profile.getSignInUserSession()?.getAccessToken().getJwtToken() : '';
    const handleSignOut = async () => {
      deleteUser(accessToken || '')
        .then(() => {
          Cookies.remove('redirectDeleteUser');
          if (redirectUrl) {
            window.location.href = redirectUrl;
          } else history.replace('/login');
        });
    };
    handleSignOut();
  };

  return (
    <div className="h-100">
      <div className="d-flex align-items-center h-100">
        <div className="mx-auto login-box">
          <div className="card">
            <CardHeader />
            <div className="card-body">
              <h5 className="card-title text-center py-1">
                Cancella il tuo profilo
              </h5>
              <p className="card-text">
                Sei sicuro di voler cancellare il tuo profilo?<br/>
                Perderai tutti i tuoi acquisti irrimediabilmente.
              </p>
              <div className="form-group mt-5 d-flex align-items-center justify-content-around">
                <button className="btn btn-primary mt-2 mb-5" onClick={() => { handleDeleteProfile(); }}>Conferma</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}